import { render } from "./hpFooter.vue?vue&type=template&id=114892b4&scoped=true"
import script from "./hpFooter.vue?vue&type=script&lang=js"
export * from "./hpFooter.vue?vue&type=script&lang=js"

import "./hpFooter.vue?vue&type=style&index=0&id=114892b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-114892b4"]])

export default __exports__